export default {
	rtl: true,
	header: {
		title: 'Dein Warenkorb',
	},
	empty_cart: '',
	shipping_option: 'Kostenloser Versand',
	product: {
		sold_out: 'Ausverkauft',
	},
	product_details: {
		atcButton: { text: 'In den Warenkorb' },
		readMore: { text: 'Mehr lesen' },
	},
	modules: {
		checkout_button: {
			button_text: { text: 'Zur Kasse' },
			button_text_loading: { text: 'Neu generieren' },
			use_coupon_code: { text: 'Rabattcode' },
			enter_coupon_code: { text: 'Rabattcode eingeben' },
			apply_coupon_code: { text: 'Anwenden' },
			edit_coupon_code: { text: 'Ändern' },
			close_coupon_code: { text: 'Schließen' },
			subtotal: { text: 'Zwischensumme' },
			savings: { text: 'Du sparst' },
			coupon_alert_text: { text: 'Rabattcode nicht anwendbar' },
		},
		random_text: {
			text: '<p class="ql-align-center">100% NO-RISK MONEY BACK GUARANTEE</p>',
		},
		order_note: {
			text: '<p> <strong>Add a note to your order</strong></p>',
		}
	},
	campaigns: {
		bundles: {
			text: 'Kaufe {{quantity}} Artikel,spare {{discount}}',
			prefix: '{{individual_price}} pro Set',
		},
		add_to_unlock: {
			title: {
				text: 'Wird oft zusammen gekauft',
			},

			show_product_details: {
				text: 'Zur Produktseite',
			},
			upsell_add_button: {
				text: 'Hinzufügen',
			},
			upsell_confirm_button: {
				text: 'Bestätigen',
			},
			discount: {
				before:
					"<p class=\"ql-align-center\">Füge Produkte im Wert von <strong>{{amount_left}}</strong> hinzu, um zusätzlich <strong>{{reward}}</strong> zu sparen</p>",
				after:
					"<p class=\"ql-align-center\">Du sparst zusätzlich <strong>{{reward}}</strong> auf deine Bestellung</p>",
			},
			free_shipping: {
				before:
					"<p class='ql-align-center'><img src='https://www.amabattery.co.za/wpimages/wp4cb45f10.gif'> Bitte Fügen Sie <b>{{amount_left}}</b> hinzu, um <b>kostenlosen Versand</b> zu erhalten<p>",
				after:
					"<p class='ql-align-center'><img src='https://media.giphy.com/media/1wX5TJZPqVw3HhyDYn/giphy.gif'> Sie haben den <b>Kostenlosen Versand</b> freigeschaltet <p>",
			},
			separator: {
				text: 'Wie wäre es mit',
			},
			gift: {
				before:
					"<p class='ql-align-center'><img src='https://www.amabattery.co.za/wpimages/wp4cb45f10.gif'> Add <b>{{amount_left}}</b> to get a <b>Free Gift</b><p>",
				after:
					"<p class='ql-align-center'><img src='https://media.giphy.com/media/1wX5TJZPqVw3HhyDYn/giphy.gif'> You've unlocked a <b>Free Gift</b><p>",
				compare_at_price: {
					text: "{{compare_at_price}}"
				},
				widget: {
					before: {
						header:
							"Spend {{goal}} Get A Free Gift 🎁",
						product_name: "Free gift: {{product_name}}",
						offer_highlight: {
							text: "Free"
						},
					},
					after: {
						header:
							"Hurry! This offer is only valid today! ⏰",
						product_name: "<p><b>You unlocked this! 🎉</b></p><p>Free gift: {{product_name}}</p>",
						offer_highlight: {
							text: "Free"
						},
					}

				}
			}
		},
		one_check_up_sell: {
			text: '<p>🔥 Add {{title}} For {{price}}</p>',
		},
	},
};

// 6f74adbe-fd22-4934-b17b-39020f42349f